import { useEffect } from 'react';
import { ToastContainer, toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import icon from '../media/favicon.ico'
import del from '../media/del.png'
import tilføj from '../media/tilføj.png'
import godkend from '../media/godkend.png'
import android1 from '../media/Android1.jpg'
import android2 from '../media/Android2.jpg'
import android3 from '../media/Android3.jpg'

function Install() {

  const isIOS = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  const isAndroid = navigator.userAgent.toLowerCase().indexOf("android") > -1;
  const isIOSApp = window.navigator?.standalone
  const isChromeApp = window.matchMedia('(display-mode: standalone)').matches
  const isStandalone = isIOSApp || isChromeApp
  const isMobile = isIOS || isAndroid

  useEffect(() => {

    const notify = () => {
      toast.info("Hent som app", {
        position: toast.POSITION.BOTTOM_CENTER,
        icon: ({ theme, type }) => <img src={icon} alt="icon" width={20} height={20} />,
        delay: 5000,
        autoClose: 30000,
        transition: Slide,
        closeOnClick: true,
        onClick: isIOS ? guideIOS : guideAndroid
      })
    }

    const guideIOS = () => {
      toast.info(
        <ol>
          <li>Klik på <br /><img src={del} alt="Del" width="80%" /></li>
          <li>Vælg "Tilføj til hjemmeskærm" <br /><img src={tilføj} alt="Tilføj til hjemmeskærm" width="80%" /></li>
          <li>Vælg "Tilføj"<br /><img src={godkend} alt="Tilføj" width="80%" /></li>
          <li>Appen er hentet</li>
        </ol>,
        {
          position: toast.POSITION.BOTTOM_CENTER,
          icon: false,
          autoClose: false,
          transition: Slide,
          closeOnClick: false,
          draggable: true,
          draggablePercent: 67
        })
    }

    const guideAndroid = () => {
      toast.info(
        <ol>
          <li>Klik på <br /><img src={android1} alt="Del" width="80%" /></li>
          <li>Vælg "Tilføj til hjemmeskærm" <br /><img src={android2} alt="Tilføj til hjemmeskærm" width="80%" /></li>
          <li>Vælg "Tilføj"<br /><img src={android3} alt="Tilføj" width="80%" /></li>
          <li>Appen er hentet</li>
        </ol>,
        {
          position: toast.POSITION.BOTTOM_CENTER,
          icon: false,
          autoClose: false,
          transition: Slide,
          closeOnClick: false,
          draggable: true,
          draggablePercent: 67
        })
    }

    if (isMobile && !isStandalone) notify()
  }, [isMobile, isStandalone, isIOS])
  if (isStandalone) return null
  return <ToastContainer />
}

export default Install